import { Fragment } from 'react';
import { trans } from '@spotahome/soyuz/client';

import styles from '../InstantBookingModal.module.scss';

const getTranslation = value =>
  value === 1
    ? trans('property_show.instant_booking_modal.month.singular')
    : trans('property_show.instant_booking_modal.month.plural', {
        nMonths: value
      });

const MinStay = props => {
  const maxValue = Math.max(...Object.values(props));
  const getWidthForValue = value => (value * 100) / maxValue;

  return (
    <li>
      {trans('property_show.instant_booking_modal.min_stay')}
      <div className={styles['instant-modal__minstay']}>
        {Object.keys(props).map(month => (
          <Fragment key={month}>
            <div className={styles['instant-modal__label']}>
              {trans(`label.month.${month}`)}
            </div>
            <div
              className={styles['instant-modal__value']}
              style={{
                width: `${getWidthForValue(props[month])}%`
              }}
            >
              {getTranslation(props[month])}
            </div>
          </Fragment>
        ))}
      </div>
    </li>
  );
};

export default MinStay;
